import React from 'react';
import { useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Container from 'components/Container';

const mock = [
  {
  field: 'Medical Course',
  },
  {
    name: 'SHIBAANI GHORAI',
    email: 'MBBS',
    title: 'MAHATMA GANDHI MEDICAL COLLEGE',    
   
    // status: '10',
    // role: 'English-88.00% A',
    
  },
  {
    name: 'APURVA.P',
    email: 'BACHELOR DENTAL SURGERY (BDS)',
    title: 'KIMS MEDICAL COLLEGE',    
   
    // status: '10',
    // role: 'English-88.00% A',
    
  },
  
 {
    field: 'Engineering Courses',
  },
  {
    name: 'RITHVIK SATISH',
    email: 'BE ELECTRONICS AND INSTRUMENTATION ',
    title: 'BIRLA INSTITUTE OF TECHNOLOGY AND SCIENCE PILANI ',
  
  },

  {
    name: 'SIDDHARTH JAI GOKULAN',            
    email: 'M. SC. MATHEMATICS',                            
    title: 'BITS PILANI, K K BIRLA GOA CAMPUS',                            
  
  },
  {
    name: 'PRATEETH GOPAL SALIGRAMA ',
    email: 'M.SC MATHEMATICS ',
    title: 'BIRLA INSTITUTE OF TECHNOLOGY, PILANI',
  
  },
  {
    name: 'ANSHUL S IYER',
    email: 'BTECH BIOI INFORMATICS ',
    title: 'VELLORE INSTITUTE OF TECHNOLOGY ',
  
  },
  {
    name: 'ADARSH SRINIDHI',
    email: 'COMPUTER SCIENCE AND ENGINEERING (SPECIALIZATION IN ARTIFICIAL INTELLIGENCE AND MACHINE LEARNING)',
    title: 'VELLORE INSTITUTE OF TECHNOLOGY, VELLORE',
  
  },
  {
    name: 'ACHIENTYA RATHORE ',
    email: 'BTECH-ELECTRONICS AND COMPUTER SCIENCE ',
    title: 'VELLORE INSTITUTE OF TECHNOLOGY',
  
  },
  {
    name: 'RONIT SINGHAL ',
    email: 'ARTIFICIAL INTELLIGENCE AND ROBOTICS ',
    title: 'MANIPAL INSTITUTE OF TECHNOLOGY ',
  
  },
  {
    name: 'LAKSHMIPRIYA P P',
    email: 'MECHATRONICS ',
    title: 'MANIPAL INSTITUTE OF TECHNOLOGY ',
  
  },
  {
    name: 'MAHISUTHAN',
    email: 'B.TECH  COMPUTER SCIENCE AND ENGINEERING',
    title: 'MANIPAL INSTITUTE OF TECHNOLOGY ',
  
  },
  {
    name: 'VATTURI NIKITH VAIKUNTA',
    email: 'BTECH ELECTRONICS IN VLSI DESIGN ',
    title: 'MANIPAL INSTITUTE OF TECHNOLOGY',
  
  },
  {
    name: 'TUSHAR VARMA',
    email: 'COMPUTER SCIENCE ENGINEERING',
    title: 'MANIPAL INSTITUTE OF TECHNOLOGY',
  
  },
  {
    name: 'RISHI PRADEEP',
    email: 'BE-MECHANICAL ENGINEERING ',
    title: 'RAMAIAH INSTITUTE OF TECHNOLOGY',
  
  },
  {
    name: 'ADITI HAREESH ',
    email: 'BTECH IN COMPUTER SCIENCE AND ENGINEERING ',
    title: 'RV UNIVERSITY MYSORE ROAD BANGALORE',
  
  },
  {
    name: 'YASH PANCHAXARI',
    email: 'B TECH,MECHANICAL ENGINEERING',
    title: 'PES , RR CAMPUS',
  
  },
  {
    name: 'SAI YATHEESH REDDY M',
    email: 'MECHANICAL ENGINEERING ',
    title: 'PES , RR CAMPUS',
  
  },
  {
    name: 'PARINITA P',
    email: 'B.TECH IN COMPUTER SCIENCE ENGINEERING',
    title: 'PES , RR CAMPUS',
  
  },
  {
    name: 'RACHITH RAMESH GUZAR',
    email: 'COMPUTER SCIENCE (CORE)',
    title: 'PES UNIVERSITY , RR CAMPUS',
  
  },
  {
    name: 'RADHIKA VAIBHAV PHADKE',
    email: 'BIOTECHNOLOGY',
    title: 'PES UNIVERSITY',
  
  },
  {
    name: 'BHAVESH SINDWANI',
    email: 'BTECH COMPUTER SCIENCE AND ENGINEERING ',
    title: 'PES UNIVERSITY ',
  
  },
  {
    name: 'SATHVIK SANJEEVAKUMAR KUBAKADDI',
    email: 'ELECTRONICS AND COMMUNICATION ENGINEERING ',
    title: 'RV COLLEGE OF ENGINEERING',
  
  },
  {
    name: 'ADITYA RAGHUNATH',
    email: 'COMPUTER SCIENCE AND ENGINEERING',
    title: 'BMS COLLEGE OF ENGINEERING',
  
  },
  {
    name: 'OM CHANDRASHEKHAR MATH',
    email: 'BE / COMPUTER SCIENCE AND ENGINEERING',
    title: 'B.M.S. COLLEGE OF ENGINEERING',
  
  },
  {
    name: 'A PRAVALIKA ',
    email: 'COMPUTER SCIENCE ',
    title: 'BMS COLLEGE OF ENGINEERING ',
  },
  {
    name: 'BHARGAVA REDDY K',
    email: 'BTECH -COMPUTER SCIENCE AND BUSINESS SYSTEM',
    title: 'NITTE MEENAKSHI INSTITUTE OF TECHNOLOGY BANGLORE ',
  
  },
  {
    name: 'T R GOKUL',
    email: 'BE, COMPUTER SCIENCE',
    title: 'BMS IT',
  
  },
  {
    name: 'G S VINAY KARTHIK ',
    email: 'COMPUTER SCIENCE ENGINEERING ',
    title: 'BMS COLLEGE OF ENGINEERING ',
  
  },
  {
    name: 'TEJAS NATARAJA',
    email: 'ROBOTICS AND ARTIFICIAL INTELLIGENCE ',
    title: 'BANGALORE INSTITUTE OF TECHNOLOGY ',
  
  },
  {
    name: 'S SRIVARI',
    email: 'INFORMATION TECHNOLOGY',
    title: 'PSG COLLEGE OF TECHNOLOGY',
  
  },
  {
    name: 'MADHUMITA KULKARNI',
    email: 'BACHELORS IN AERONAUTICAL ENGINEERING',
    title: 'UNIVERSITY OF LIMERICK',
  
  },
  {
    name: 'RAKSHITH V NAIR',
    email: 'MECHANICAL ENGINEERING ',
    title: 'BANGALORE INSTITUTE OF TECHNOLOGY',
  
  },
  {
    name: 'GANAV A',
    email: 'AIML ( ARTIFICIAL INTELLIGENCE AND MACHINE LEARNING )',
    title: 'DAYAND SAGAR ACADEMY OF TECHNOLOGY ',
  
  },
  {
    name: 'VRIDDHI DHINGRA ',
    email: 'COMPUTER SCIENCE AND ENGINEERING WITH SPECIALISATION IN DATA SCIENCE ',
    title: 'SRM INSTITUTE OF SCIENCE AND TECHNOLOGY ',
  
  },
  {
    name: 'DHANYA SHETTIGAR',
    email: 'B.TECH BIOTECHNOLOGY CORE',
    title: 'SRM  UNIVERSITY OF SCIENCE AND TECHNOLOGY KATTANKULATUR ',
  
  },
  {
    name: 'MAYURI  NAVEEN',
    email: 'B TECH',
    title: 'BIO MEDICAL, SRM COLLEGE',
  
  },
  {
    name: 'KRUTHIKA SAKHARE',
    email: 'BTECH COMPUTER SCIENCE ENGINEERING (AI&ML)',
    title: 'REVA UNIVERSITY ',
  
  },
  {
    name: 'DHRITHI.P',
    email: 'AERONAUTICAL ENGINEERING ',
    title: 'DR AMBEDKAR INSTITUTE OF TECHNOLOGY ',
  
  },
   {
    name: 'BHARAT SONI ',
    email: 'B TECH IN FOOD TECHNOLOGY',
    title: 'AMITY UNIVERSITY RAJASTHAN ',
  
  },

  {
    field: 'Other Professional Courses',
   },
   {
     name: 'YOGIT CHOUDHARY',
     email: 'B COM ',
     title: 'UNIVERSITY OF MELBOURNE',
    
   },
   {
     name: 'IRA RAJAN ',
     email: 'FASHION COMMUNICATION ',
     title: 'NATIONAL INSTITUTE OF FASHION TECHNOLOGY ',
     
   },
   {
     name: 'SHAHANA K',
     email: 'B DESIGNING ',
     title: 'NATIONAL INSTITUTE OF FASHION TECHNOLOGY ',
     
   },
   {
     name: 'VANYA SINGH',
     email: 'B DESIGNING ',
     title: 'PES UNIVERSITY',
   
   },
   {
     name: 'TANUSHA R ',
     email: 'BA LLB',
     title: 'PES UNIVERSITY ',
   
   },
   {
     name: 'PRAPTI MANJUNATH ',
     email: 'BACHELORS IN DESIGNING ',
     title: 'PES UNIVERSITY ',
   
   },
   {
     name: 'SHRUTHI NARAYANAN',
     email: 'COMMERCE WITH ACCA',
     title: 'ST JOSEPH COLLEGE OF COMMERCE ',
   
   },
   {
     name: 'BHAVIK JAGDISH RANE ',
     email: 'B.B.A - BACHELOR OF BUSINESS ADMINISTRATION ',
     title: 'ST. JOSEPH`S COLLEGE OF COMMERCE ',
   
   },
   {
     name: 'ADWITA NEGI ',
     email: 'BCOM.(ANALYTICS)',
     title: 'ST. JOSEPH`S COLLEGE OF COMMERCE ',
   
   },
   {
     name: 'RAKADYUTI SAHA',
     email: 'BACHELOR OF SCIENCE, TRIPLE MAJOR IN ECONOMICS, MATHEMATICS, STATISTICS.',
     title: 'MOUNT CARMEL COLLEGE',
   
   },
   {
     name: 'TANUSH KUMAR AGGARWAL ',
     email: 'BBA',
     title: 'CHRIST UNIVERSITY ',
   
   },
   {
     name: 'MIHIKA ACHARYA',
     email: 'B.COM PROFESSIONAL ',
     title: 'CHRIST UNIVERSITY CENTRAL CAMPUS',
   
   },
   {
     name: 'VIVIKTH M',
     email: 'B.COM',
     title: 'CHRIST UNIVERSITY (HOSUR ROAD)',
   
   },
   {
     name: 'A R SANJANA ',
     email: 'BBA FINANCE AND ECONOMICS',
     title: 'CHRIST UNIVERSITY-YESHWANTHPUR CAMPUS ',
   
   },
   {
     name: 'SARVAJITH ITAGI',
     email: 'B.COM ACCOUNTANT & TAXATION ',
     title: 'CHRIST UNIVERSITY BENGALURU CENTRAL CAMPUS ',
   
   },
   {
     name: 'E SREEPRABHA',
     email: 'B COM - FINANCE AND INVESTMENT',
     title: 'CHRIST UNIVERSITY , YESHWANTHPUR',
   
   },
   {
     name: 'MINCHANA C A',
     email: 'BBA LLB',
     title: 'CHRIST UNIVERSITY , MAIN',
   
   },
   {
     name: 'PRIYANSHU BAID',
     email: 'B COM ,INTEGRATED COURSE',
     title: 'CHRIST UNIVERSITY , MAIN',
   
   },
   {
     name: 'VINAYAK MAHESHWARI',
     email: 'B COM ',
     title: 'CHRIST UNIVERSITY , YESHWANTHPUR',
   
   },
   {
     name: 'SANSKRITI',
     email: 'B COM -INVESTMENT BANKING ',
     title: 'MOUNT CARMEL',
   
   },
   {
     name: 'SKANDHA KIRAN',
     email: 'PILOT TRAINING + BSC IN AVIATION ',
     title: 'NITTE MEENAKSHI INSTITUTE OF TECHINOLOGY ',
   
   },
   {
     name: 'RIYA GOEL',
     email: 'BACHELOR OF DESIGN',
     title: 'R V UNIVERSITY',
   
   },
    {
     name: 'NIKKITHA S',
     email: 'BACHELORS IN DESIGN ( BDES ) ',
     title: 'RV UNIVERSITY ',
   
   },
   {
     name: 'POORVI SATISH ',
     email: 'BCOM (HONS) INTEGRATED WITH ACCA',
     title: 'MANIPAL ACADEMY OF HIGHER EDUCATION(MAHE)',
   
   },
   {
     name: 'ANKUR KOTHARI',
     email: 'BCOM HONS (ACCA)',
     title: 'MANIPAL ACADEMY OF HIGHER EDUCATION ',
   
   },
   {
     name: 'SURYA S KUMAR',
     email: 'BACHELORS IN COMMERCE WITH ACCA',
     title: 'MANIPAL ACADEMY OF HIGHER EDUCATION ',
   
   },
    {
     name: 'MANNE RUTHVIK CHOWDARY',
     email: 'ARCHITECTURE ',
     title: 'DAYANAND SAGAR COLLEGE OF ARCHITECTURE ',
   
   },
    {
     name: 'LIKITH RAJ B Y',
     email: 'BCA (HONOURS) AI',
     title: 'MSRIT',
   
   },
   {
     name: 'KAARTHIKEYAN R',
     email: 'B COM ',
     title: 'M S RAMAIAH',
   
   },
   {
     name: 'ADVAITA BIJU',
     email: 'B DESIGNING ',
     title: 'SRISHTI COLLEGE OF DESIGN',
   
   },
   {
     name: 'RAJAN JEEVAN',
     email: 'B COM ',
     title: 'JAIN COLLEGE',
   
   },
    {
     name: 'SAANVI SINGH',
     email: 'LAW',
     title: 'CHRIST (DEEMED TO BE UNIVERSITY), CENTRAL CAMPUS ',
   
   },
   {
     name: 'SMRITHI GORUR',
     email: 'BA LLB',
     title: 'RAMAIAH COLLEGE OF LAW',
   
   },
   {
     name: 'AARATRIKA SHARMA ',
     email: 'BACHELOR OF ARTS AND BACHELOR OF LEGISLATIVE LAW (BA LLB)',
     title: 'RAMAIAH COLLEGE OF LAW',
   
   },
   
];

 const Simple = () => {
  const theme = useTheme();
  return (
   
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 200 }} aria-label="simple table">
         
          <TableBody>
            {mock.map((item, i) => (
              <TableRow
                key={i}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                }}
              >
                <TableCell component="th" scope="row">
                <Typography
                  align='left'
                  variant={'h6'}
                  fontWeight={600}
                  color={'blue'}
                >
                  {item.field}
                </Typography>
                  <Typography variant={'subtitle2'} fontWeight={700}>
                    {item.name}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.email}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.title}
                  </Typography>
                </TableCell>
               
           
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

  );
};

export default Simple;